import React from "react";
import "./Dashboard.css";
import { useSettings } from "../../context/SettingsContext";
import { useNavigate } from "react-router";
export default function DashboardCard({
  title,
  number,
  icon,
  extraInfo,
  path,
}) {
  const { settings } = useSettings();
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(path);
  };
  return (
    <div className="card dashboard-card-responsive" onClick={handleNavigate}>
      <div className="card-header">
        <div className="title-section">
          <div className="icon-with-tooltip" data-tooltip={title}>
            {icon}
          </div>
          <span className="card-title">{title}</span>
        </div>
        <span className="card-number">{number}</span>
      </div>
      {extraInfo && extraInfo.length > 0 && (
        <div className="extra-info">
          {extraInfo.map((info, index) => (
            <div key={index} className="info-item">
              <div className="icon-with-tooltip" data-tooltip={info.title}>
                {info.icon}
              </div>
              <span className="info-number">{info.number}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
